import React from "react";
import { NavLink } from "react-router-dom";
import { NavDropdown } from "react-bootstrap";

import "./NavBar.css";
import img1 from "../Images/kulogo.jpeg";

function NavBar() {
  <link
    rel="stylesheet"
    href="https://cdn.jsdelivr.net/npm/bootstrap@5.2.2/dist/css/bootstrap.min.css"
    integrity="sha384-Zenh87qX5JnK2Jl0vWa8Ck2rdkQ2Bzep5IDxbcnCeuOxjzrPF/et3URy9Bv1WTRi"
    crossorigin="anonymous"
  />;
  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light bg-light">
        <div className="container-fluid shadow">
          <a className="navbar-brand" href="/">
            <img src={img1} alt="KU LOGO" className="nav-logo" />
          </a>
          <center>
            <b>EXAMINATION BRANCH</b>
            <br />
            KAKATIYA UNIVERSITY
          </center>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav ms-auto">
            <li className="nav-item p-2">
                <NavLink
                  to="/instructions"
                  exact
                  className="nav-link"
                  aria-current="page"
                  activeClassName="active"
                >
                  Instructions For Scholars
                </NavLink>
              </li>
              <li className="nav-item p-2">
                <NavLink
                  to="/"
                  exact
                  className="nav-link"
                  aria-current="page"
                  activeClassName="active"
                >
                  Home
                </NavLink>
              </li>
              <li className="nav-item p-2">
                <NavLink
                  to="/about"
                  className="nav-link"
                  aria-current="page"
                  activeClassName="active"
                >
                  About Us
                </NavLink>
              </li>
              <li className="nav-item  p-2">
                <NavDropdown title="Services" id="basic-nav-dropdown">
                <NavDropdown.Item className="services-list" href="/">
                    Scholar Login
                  </NavDropdown.Item>
                  <NavDropdown.Item className="services-list" href="/pvtOfficer-login">
                    Officer login
                  </NavDropdown.Item>
                  <NavDropdown.Item className="services-list" href="/bospanel-login">
                    BOS Login
                  </NavDropdown.Item>
                  <NavDropdown.Item className="services-list" href="/officers-login">
                    Administrative Officer Login
                  </NavDropdown.Item>
                </NavDropdown>
              </li>
              <li className="nav-item p-2">
                <NavLink
                  to="/contact"
                  className="nav-link"
                  aria-current="page"
                  activeClassName="active"
                >
                  Contact Us
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}

export default NavBar;
